import {useMutation} from 'react-query';
import {postCheckOtpCode} from './postCheckOtpCode';

const usePostCheckOtpCode = () => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IPostCheckOtpCode) => postCheckOtpCode(payload),
  });

  return {mutate, isLoading};
};

export default usePostCheckOtpCode;
